import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon", "button"];

  toggle() {
    const showing = this.inputTarget.type === "password";
    this.inputTarget.type = showing ? "text" : "password";
    this.showIconTarget.classList.toggle("d-none", showing);
    this.hideIconTarget.classList.toggle("d-none", !showing);
    this.buttonTarget.setAttribute("aria-label", showing ? "Hide password" : "Show password");
    this.buttonTarget.setAttribute("aria-pressed", showing.toString());
  }
}
